/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type pdpSharedNotificationTradeMicroGoalConfigQueryVariables = {
    readonly itemId?: string | null;
    readonly userId?: string | null;
    readonly buyerId?: ReadonlyArray<string | null> | null;
};
export type pdpSharedNotificationTradeMicroGoalConfigQueryResponse = {
    readonly viewer: {
        readonly transactions: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly checkoutDate: string | null;
                } | null;
            } | null> | null;
        } | null;
        readonly conversationsSolr: {
            readonly totalResults: number | null;
        } | null;
        readonly item: {
            readonly canBuyerMakeOffer: boolean | null;
            readonly displayInfo: {
                readonly ctas: {
                    readonly showRequestOnApproval: boolean | null;
                    readonly showHoldRequest: boolean | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type pdpSharedNotificationTradeMicroGoalConfigQuery = {
    readonly response: pdpSharedNotificationTradeMicroGoalConfigQueryResponse;
    readonly variables: pdpSharedNotificationTradeMicroGoalConfigQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "itemId",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "buyerId",
            "type": "[String]",
            "defaultValue": ([] /*: any*/)
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "buyerId"
        } as any),
        ({
            "kind": "Literal",
            "name": "first",
            "value": 1
        } as any),
        ({
            "kind": "Literal",
            "name": "sort",
            "value": "checkoutDate desc"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "checkoutDate",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userId"
    } as any), v4 = ({
        "kind": "Variable",
        "name": "itemId",
        "variableName": "itemId"
    } as any), v5 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "conversationsSolr",
        "storageKey": null,
        "args": [
            (v3 /*: any*/),
            (v4 /*: any*/)
        ],
        "concreteType": "ConversationsSolrConnection",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalResults",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v6 = [
        (v4 /*: any*/),
        ({
            "kind": "Literal",
            "name": "pageType",
            "value": "PDP"
        } as any)
    ], v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "canBuyerMakeOffer",
        "args": [
            (v3 /*: any*/)
        ],
        "storageKey": null
    } as any), v8 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "displayInfo",
        "storageKey": null,
        "args": [
            (v3 /*: any*/),
            {
                "kind": "Literal",
                "name": "page",
                "value": "pdp"
            }
        ],
        "concreteType": "ItemDisplayInfo",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "ctas",
                "storageKey": null,
                "args": null,
                "concreteType": "CTADisplay",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showRequestOnApproval",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showHoldRequest",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "pdpSharedNotificationTradeMicroGoalConfigQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "transactions",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "TransactionConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TransactionEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Transaction",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        (v5 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": (v6 /*: any*/),
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                                (v7 /*: any*/),
                                (v8 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "pdpSharedNotificationTradeMicroGoalConfigQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "transactions",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "TransactionConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TransactionEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Transaction",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v9 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        (v5 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": (v6 /*: any*/),
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/)
                            ]
                        },
                        (v9 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "pdpSharedNotificationTradeMicroGoalConfigQuery",
            "id": "app-buyer-finding/234.0.0-2019-09-27T13:34:34.101Z/pdpSharedNotificationTradeMicroGoalConfigQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'e66940b62d17c074921b78518e075731';
export default node;
